var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 30,
    fill: "#062134"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5914 60.0407L169.982 82.4122C171.68 82.8236 173.391 81.7799 173.802 80.0816L175.91 71.375C176.322 69.6764 175.278 67.966 173.579 67.5546L76.3029 44L17.9391 68.5312C16.328 69.2083 15.5708 71.0633 16.248 72.6743L19.7191 80.9328C20.3963 82.5438 22.2513 83.3011 23.8624 82.6239L77.5914 60.0407Z",
    fill: "url(#paint0_linear_105_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5878 93.5264L162.336 114.076C164.035 114.488 165.745 113.445 166.157 111.747L168.268 103.041C168.68 101.343 167.637 99.6319 165.939 99.2199L76.3062 77.4857L29.9546 96.9377C28.3431 97.6139 27.585 99.4686 28.2613 101.08L31.7278 109.34C32.404 110.952 34.2587 111.71 35.8702 111.034L77.5878 93.5264Z",
    fill: "url(#paint1_linear_105_3)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6186 129.913L154.375 147.96C156.076 148.36 157.78 147.305 158.18 145.604L160.23 136.883C160.63 135.182 159.575 133.479 157.874 133.079L76.2747 113.893L43.049 127.876C41.4383 128.553 40.682 130.409 41.3599 132.02L44.8344 140.276C45.5125 141.887 47.3678 142.644 48.9785 141.966L77.6186 129.913Z",
    fill: "url(#paint2_linear_105_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_105_3",
    x1: 15.5256,
    y1: 51.1835,
    x2: 96.6928,
    y2: 104.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_105_3",
    x1: 29.9235,
    y1: 83.9351,
    x2: 98.9077,
    y2: 139.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFFDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_105_3",
    x1: 24.7021,
    y1: 120.959,
    x2: 112.356,
    y2: 168.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89FF9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FFFDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApp);
export default __webpack_public_path__ + "static/media/logo_app.0059a4a01ca6cf47744b92298436a1f6.svg";
export { ForwardRef as ReactComponent };